import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { ToastContainer } from 'react-toastify';
const NotificationsContainer = ({ stacked }) => {
    const wrapperClasses = classNames('notification-container-wrapper', stacked && 'stacked');
    return (_jsx("div", { className: wrapperClasses, children: _jsx(ToastContainer, { className: 'notification-container', stacked: false, limit: 5 }) }));
};
export default NotificationsContainer;
